import { Component, OnInit } from '@angular/core';
import { UserService } from "../../services/user.service";

import { environment } from 'src/environments/environment';
import { DomSanitizer } from '@angular/platform-browser';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-documentos',
  templateUrl: './documentos.component.html',
  styleUrls: ['./documentos.component.css'],
  providers: [UserService]
})
export class DocumentosComponent implements OnInit {
  identiti;
  doc
  config
  actual = environment.actual;
  nombre = environment.entidad[this.actual].nombreDocumentos
  constructor(private _userService: UserService, private sanitizer: DomSanitizer, private spinner: NgxSpinnerService) { }

  ngOnInit() {
    this.spinner.show()
    this.identiti = JSON.parse(this._userService.GetsessionStorage('identity'));
    this.config = JSON.parse(this._userService.GetsessionStorage('config'));
    this.consultaDocumentos();
  }

  consultaDocumentos() {
    this._userService.httpGet('consultaDocumentos').subscribe(
      response => {
        this.doc = response
        console.log(this.doc)
        this.spinner.hide()
      },
      error => {
        console.log(error)
        this.spinner.hide()
      }
    )
  }

  sanitize(url: string) {
    return this.sanitizer.bypassSecurityTrustUrl(url);
  }

}
